<template></template>

<script>
// 使用 https://wordtohtml.net/ 服務

import _ from "lodash";
export default {
  props: ["q"],
  computed: {
    mapQ() {
      let data = {};
      _.each(this.q, (value, key) => {
        key = this.keyTrim(key);
        data[key] = value;
      });
      return data;
    },
  },
  methods: {
    keyTrim(value) {
      return value
        .replace(/^[a-zA-Z] ?/, "")
        .replace(/^＊ */, "")
        .replace(/^[0-9]-?[0-9]?. ?/, "");
    },
    ifq(keys, value, trueIcon, falseIcon) {
      let keyArr = Array.isArray(keys) ? keys : [keys];
      let matched = keyArr.some((key) => {
        key = this.keyTrim(key);
        let qValue = this.mapQ[key];
        return this.q && qValue && qValue.includes(value);
      });
      return matched ? trueIcon : falseIcon;
    },
    ifqOther(key, value) {
      key = this.keyTrim(key);
      let qValue = this.mapQ[key];
      return this.q && qValue && qValue.includes(value)
        ? this.mapQ[key].split(",")[1] || ""
        : "";
    },
    ift(key) {
      key = this.keyTrim(key);
      return this.q && this.mapQ[key] ? this.mapQ[key] : "";
    },
    ifet(key, value, text) {
      key = this.keyTrim(key);
      return this.q && this.mapQ[key] == value ? text : "";
    },
    iftf(key, trueIcon, falseIcon, trueValue = "是", falseValue = "否") {
      key = this.keyTrim(key);
      if (this.q && this.mapQ[key] == trueValue) return trueIcon;
      if (this.q && this.mapQ[key] == falseValue) return falseIcon;
      return "";
    },
  },
};
</script>

<style></style>
